"use strict";

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typeChecks_1 = require("./typeChecks");

var isArrayLike_1 = require("./isArrayLike");

var OPEN_CHAR = '{';
var CLOSE_CHAR = '}';
var MODIFIER_SEPARATOR = ':';

function safe(action, defaultResult) {
  try {
    var result = action();
    return !typeChecks_1.isUndefined(result) ? result : defaultResult;
  } catch (e) {
    if (e.name === 'TypeError' || e.name === 'ReferenceError') {
      return defaultResult;
    }

    throw e;
  }
}

exports.safe = safe;
/**
 * Will get the value specified in the string notation from the instance that is passed to it.
 *
 * @export
 * @param {(string |)} [stringNotation=null | undefined]
 * @param {({} |)} [instance=null | undefined]
 * @param {*} [defaultValue=null]
 * @returns {*}
 */

function getValueFromStringNotation(stringNotation, instance, defaultValue) {
  var value = null;
  var parameterList = getInnerParameters(stringNotation);

  if (parameterList && parameterList.length > 0) {
    var parameters = {};

    for (var _i = 0, parameterList_1 = parameterList; _i < parameterList_1.length; _i++) {
      var parameter = parameterList_1[_i];
      var parameterValue = getValueFromDotNotation(parameter, instance, defaultValue);

      if (parameterValue) {
        parameters[parameter] = parameterValue;
      }
    }

    value = stringNotation;

    for (var _a = 0, _b = Object.keys(parameters); _a < _b.length; _a++) {
      var parameter = _b[_a];
      var fullParameter = "" + OPEN_CHAR + parameter + CLOSE_CHAR;
      value = value.split(fullParameter).join(parameters[parameter]);
    }
  } else {
    value = getValueFromDotNotation(stringNotation, instance, defaultValue);
  }

  if (typeChecks_1.isNullOrUndefined(value)) {
    value = defaultValue;
  }

  return value;
}

exports.getValueFromStringNotation = getValueFromStringNotation;
/**
 * This will get the value from the property for a complex identifier (If the source field is deeper than the base object it will traverse)
 *
 * @export
 * @param {(string |)} [sourceField=null | undefined]
 * @param {({} |)} [instance=null | undefined]
 * @param {*} [defaultValue=null]
 * @returns {*}
 */

function getValueFromDotNotation(sourceField, instance, defaultValue) {
  if (defaultValue === void 0) {
    defaultValue = null;
  }

  var currentObj = instance;
  var value = defaultValue;

  if (!typeChecks_1.isNullOrUndefined(sourceField)) {
    var modifierDetails = null;

    if (sourceField.indexOf(MODIFIER_SEPARATOR) > -1) {
      modifierDetails = sourceField.split(MODIFIER_SEPARATOR);
      sourceField = modifierDetails.shift();
    }

    var sourceFieldSplit = sourceField.split('.');

    var _loop_1 = function _loop_1() {
      if (!currentObj) {
        return "break";
      }

      var attr = sourceFieldSplit.shift();

      if (!typeChecks_1.isNullOrUndefined(attr)) {
        if (sourceFieldSplit.length > 0) {
          currentObj = safe(function () {
            return currentObj[attr];
          }, null);
        } else {
          value = safe(function () {
            return currentObj[attr];
          }, defaultValue);
        }
      }
    };

    while (sourceFieldSplit.length > 0) {
      var state_1 = _loop_1();

      if (state_1 === "break") break;
    }

    if (modifierDetails) {
      value = applyModifier(value, modifierDetails);
    }
  }

  return value;
}

exports.getValueFromDotNotation = getValueFromDotNotation;
/**
 * Will take in the original value and details on how to modify it. This allows for uppercase, lowercase etc
 *
 * @export
 * @param {*} value
 * @param {string[]} [modifierDetails=[]]
 * @returns {*}
 */

function applyModifier(value, modifierDetails) {
  if (modifierDetails === void 0) {
    modifierDetails = [];
  }

  if (modifierDetails && modifierDetails.length > 0 && !typeChecks_1.isNullOrUndefined(value) && typeof value !== 'object') {
    var firstModifier = modifierDetails[0]; // Upper case

    if (firstModifier === 'U') {
      value = value.toString().toUpperCase();
    }

    if (firstModifier === 'L') {
      value = value.toString().toLowerCase();
    }
  }

  return value;
}

exports.applyModifier = applyModifier;
/**
 * Fetches parameters that are inside the string that are wrapped with the opening and closing tags ({})
 *
 * @export
 * @param {string} stringNotation
 * @returns {string[]}
 */

function getInnerParameters(stringNotation) {
  var result = [];
  var workingNotation = stringNotation;
  var isOpen = false;
  var currentParameter = '';

  for (var _i = 0, _a = workingNotation.split(''); _i < _a.length; _i++) {
    var char = _a[_i];

    if (char === OPEN_CHAR) {
      if (!isOpen) {
        currentParameter = '';
        isOpen = true;
      } else {
        throw new Error('object: getInnerParameters: Nested parameters not supported in string notation');
      }
    } else if (char === CLOSE_CHAR) {
      if (isOpen) {
        isOpen = false;
        result.push(currentParameter);
        currentParameter = '';
      } else {
        throw new Error('object: getInnerParameters: No opening tag found for parameter');
      }
    } else if (isOpen) {
      currentParameter += char;
    }
  }

  if (isOpen) {
    throw new Error("object: getInnerParameters: No closing tag found for parameter (" + currentParameter + ")");
  }

  return result;
}

exports.getInnerParameters = getInnerParameters;
/**
 * Will return a merged object
 *
 * @export
 * @param {any[]} elements
 * @returns {any}
 */

function deepMergeObjects() {
  var elements = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    elements[_i] = arguments[_i];
  }

  return deepMergeObjectsWithOptions.apply(void 0, __spreadArrays([null], elements));
}

exports.deepMergeObjects = deepMergeObjects;
/**
 * Will return a merged object, based on options
 *
 * @export
 * @param {any[]} elements
 * @returns {any}
 */

function deepMergeObjectsWithOptions(options) {
  var elements = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    elements[_i - 1] = arguments[_i];
  }

  var mergeOptions = Object.assign({
    arrayMergeStrategy: 'DeepCopy'
  }, options);
  elements = elements.filter(function (e) {
    return e;
  });

  if (elements.length < 1) {
    console.warn('Need 1 or more elements to merge');
    return;
  }

  var workingElement = {};
  var elementLength = elements.length;

  for (var i = 0; i < elementLength; i++) {
    var element = elements[i];

    if (element && Object.keys(element).length > 0) {
      workingElement = mergeRecursive(mergeOptions, workingElement, element);
    }
  }

  return workingElement;
}

exports.deepMergeObjectsWithOptions = deepMergeObjectsWithOptions;

function copyIsObject(obj) {
  return !!obj && obj.constructor === Object && !isArrayLike_1.isObservableArray(obj);
}

function deepcopy(instance) {
  if (isArrayLike_1.isArrayLike(instance)) {
    return instance.map(function (item) {
      return deepcopy(item);
    });
  }

  if (copyIsObject(instance)) {
    var response = {};

    for (var _i = 0, _a = Object.keys(instance); _i < _a.length; _i++) {
      var key = _a[_i];
      response[key] = deepcopy(instance[key]);
    }

    return response;
  }

  return instance;
}

function mergeRecursive(options, obj1, obj2) {
  var keys = Object.keys(obj2);
  var keysLength = keys.length;

  var _loop_2 = function _loop_2(i) {
    var _a;

    var key = keys[i];

    try {
      // Property in destination object set; update its value.
      if (isArrayLike_1.isArrayLike(obj2[key])) {
        if (options.arrayMergeStrategy === 'DeepMerge') {
          for (var j = 0; j < obj2[key].length; j++) {
            if (!obj1[key][j]) {
              obj1[key][j] = obj2[key][j];
            } else {
              obj1[key][j] = mergeRecursive(options, obj1[key][j], obj2[key][j]);
            }
          }
        } else if (options.arrayMergeStrategy === 'DeepCopy') {
          obj1[key] = obj2[key].map(function (item) {
            return deepcopy(item);
          });
        } else if (options.arrayMergeStrategy === 'AppendDeepCopy') {
          if (!obj1[key]) {
            obj1[key] = [];
          }

          for (var j = 0; j < obj2[key].length; j++) {
            obj1[key].push(deepcopy(obj2[key][j]));
          }
        } else if (options.arrayMergeStrategy === 'DeepMergeByKeyOrAppend') {
          if (!obj1[key]) {
            obj1[key] = [];
          }

          var itemsToPush = [];

          var _loop_3 = function _loop_3(j) {
            var obj2Key = options.getKeyFn(obj2[key][j]);
            var merged = false;
            obj1[key].forEach(function (item, index) {
              var obj1Key = options.getKeyFn(item);

              if (obj1Key === obj2Key) {
                obj1[key][index] = mergeRecursive(options, obj1[key][index], obj2[key][j]);
                merged = true;
              }
            });

            if (!merged) {
              itemsToPush.push(obj2[key][j]);
            }
          };

          for (var j = 0; j < obj2[key].length; j++) {
            _loop_3(j);
          }

          (_a = obj1[key]).push.apply(_a, itemsToPush);
        } else {
          obj1[key] = obj2[key];
        }
      } else if (copyIsObject(obj2[key])) {
        obj1[key] = mergeRecursive(options, obj1[key] || {}, obj2[key]);
      } else {
        obj1[key] = obj2[key];
      }
    } catch (e) {
      // Property in destination object not set; create it and set its value.
      obj1[key] = obj2[key];
    }
  };

  for (var i = 0; i < keysLength; i++) {
    _loop_2(i);
  }

  return obj1;
}